"use client";

import { useCallback, useState } from "react";

export function useMenuOverlay(initial = false) {
  const [open, setOpen] = useState(initial);
  const openMenu = useCallback(() => setOpen(true), []);
  const closeMenu = useCallback(() => setOpen(false), []);
  const toggleMenu = useCallback(() => setOpen((v) => !v), []);
  return { open, openMenu, closeMenu, toggleMenu, setOpen };
}
